import RestService from '../services/rest';

const parseResponsePayload = (data) => {
  try {
    const text = new TextDecoder('utf-8').decode(data);

    if (text.charAt(0) !== '{') {
      return null;
    }

    return JSON.parse(text);
  } catch (e) {
    return null;
  }
};

const resolveFileName = (headers = {}) => {
  const contentDisposition = headers['content-disposition'] || '';
  const quotedMatch = contentDisposition.match(/filename="([^"]+)"/);
  if (quotedMatch) {
    return quotedMatch[1];
  }

  const unquotedMatch = contentDisposition.match(/filename=([^;]+)/);
  if (unquotedMatch) {
    return unquotedMatch[1].trim();
  }

  if (headers['x-apk-file-name']) {
    return headers['x-apk-file-name'];
  }

  return 'BeeStock.apk';
};

const downloadLatestApk = async () => {
  const response = await RestService.postAuthenticated(
    'settings/apkDownload',
    {},
    {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.android.package-archive',
    },
    { responseType: 'arraybuffer', returnFullResponse: true },
  );

  const payload = parseResponsePayload(response.data);

  if (payload && payload.success === false) {
    return {
      success: false,
      apkNotFound: payload.apkNotFound || false,
      invalidCredentials: payload.invalidCredentials || false,
      clientNotConfigured: payload.clientNotConfigured || false,
      versionTooOld: payload.versionTooOld || false,
      minVersion: payload.minVersion || '',
    };
  }

  const fileName = resolveFileName(response.headers);

  const url = window.URL.createObjectURL(
    new Blob([response.data], { type: 'application/vnd.android.package-archive' }),
  );
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);

  return {
    success: true,
  };
};

export default { downloadLatestApk };
